import Accordion from './Accordion'
import DataBlock from './DataBlock'
import DataInfo from './DataInfo'

import type { IBCKSKepalaSekolahEligibility } from 'types/bcks'
import type { FC } from 'react'

interface BlockAllocationProps {
  data: IBCKSKepalaSekolahEligibility['currentAssignment']
}

const BlockAllocation: FC<BlockAllocationProps> = ({ data }) => {
  return (
    <Accordion title="Penugasan Saat Ini">
      <div className="space-y-4">
        <>
          <DataBlock label="Jenjang Satuan Pendidikan">
            {!!data?.namaSekolah.value || !!data?.alamatSekolah.value ? (
              <>
                {data.namaSekolah.value}
                {data?.alamatSekolah.value && (
                  <div>{data?.alamatSekolah.value}</div>
                )}
              </>
            ) : (
              data?.namaSekolah.validation || data?.alamatSekolah.validation
            )}
          </DataBlock>
        </>

        {/* <DataBlock label="Periode Penugasan">
          {data?.tanggalPeriodePenugasan || '-'}
        </DataBlock> */}

        <DataBlock label="Kecamatan">
          {data?.kecamatanSekolah.value || data?.kecamatanSekolah.validation}
        </DataBlock>
        <DataBlock label="Kabupaten/Kota">
          {data?.kabupatenSekolah.value || data?.kabupatenSekolah.validation}
        </DataBlock>
        <DataBlock label="Provinsi">
          {data?.provinsiSekolah.value || data?.provinsiSekolah.validation}
        </DataBlock>

        <DataInfo />
      </div>
    </Accordion>
  )
}
export default BlockAllocation
